<template>
  <div class="TABLE_LIST">
    <virtual-scroll
      ref="virtualScroll"
      :key="key"
      :data="tableData"
      :item-size="62"
      key-prop="id"
      @change="(virtualList) => list = virtualList"
    >
      <el-table
        ref="table"
        :key="key"
        border
        :data="list"
        class="table-height"
        :height="tableHeightRow.height"
        row-key="id"
        :fit="true"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <virtual-column width="50" type="selection" />
        <virtual-column :label="$t('GlobalSetObj.serial')" width="50" type="index" />
        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :align="item.fixed"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :class-name="'ellipsis'"
        >
          <template slot-scope="scope">
            <el-link
              v-if="item.prop === 'waybillNumber' || item.prop === 'transportNumber'"
              type="primary"
              @click="editFee(scope.row)"
            >{{ scope.row[item.prop] }}</el-link>

            <div v-else-if="item.prop === 'status'">{{ scope.row.statusStr }}</div>

            <div v-else-if="item.prop === 'collectType'">{{ scope.row.collectTypeStr }}</div>

            <div v-else-if="item.prop === 'feeSource'">{{ scope.row.feeSourceStr }}</div>

            <!-- 商户号(商家编码) -->
            <div v-else-if="item.prop === 'merchantCode'">
              {{ scope.row[item.prop] }}{{ scope.row['merchantName']?`(${scope.row['merchantName']})`:'' }}
            </div>

            <!-- 车型-->
            <div v-else-if="item.prop === 'vehicleType'">{{ scope.row.vehicleTypeStr }}</div>

            <!--AJD、DSP显示账号类型 customerType 1 自营 2 第三方-->
            <div v-else-if="item.prop === 'customerType'">
              {{ scope.row.customerType === 1
                ? $t('GlobalSetObj.selfSupport')
                : scope.row.customerType === 2 ? $t('GlobalSetObj.three') : ''
              }}
            </div>

            <!-- 运输类型 -->
            <div v-else-if="item.prop === 'routeType'">{{ TRANSPORTATION_TYPE[scope.row.routeType] && TRANSPORTATION_TYPE[scope.row.routeType].label || '' }}</div>

            <!--第三方揽收显示业务类型 orderBusinessType 1 快递 0 揽收-->
            <div v-else-if="item.prop === 'orderBusinessType'">
              {{ scope.row.orderBusinessType === 1
                ? $t('collectionCenter.expressDelivery')
                : scope.row.orderBusinessType === 0 ? $t('GlobalSetObj.Collect') : ''
              }}
            </div>

            <!-- 货物类型-->
            <div v-else-if="item.prop === 'cargoType'">{{ CARGO_TYPE[scope.row.cargoType] && CARGO_TYPE[scope.row.cargoType].label || '' }}</div>

            <!-- 车线类型-->
            <div v-else-if="item.prop === 'tripType'">{{ CAR_LINE_TYPE[scope.row.tripType] && CAR_LINE_TYPE[scope.row.tripType].label || '' }}</div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

        <el-table-column
          v-for="item in currentColumnsArr"
          :key="item.key"
          :label="item.label"
          :prop="item.prop"
          :show-overflow-tooltip="true"
          :render-header="renderHeader"
          :class-name="'ellipsis'"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </virtual-scroll>

    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[50, 100, 200]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="onCurrentChange"
        @size-change="onSinzeChange"
      />
    </div>
  </div>
</template>

<script>
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils.js';
import {
  WAYBILL_STATUS,
  ORDER_TYPE_LIST,
  FEE_SOURCE,
  COLLECT_TYPE,
  CARGO_TYPE,
  CAR_LINE_TYPE
} from '@/views/finance/enums.js';
import { asyncGetList } from './utils.js';
import { apiPayableTransportExpenseGetPage } from '@/api/finance/receivables';

export default {
  directives: {
    ElTableInfiniteScroll
  },

  components: {
    VirtualScroll,
    VirtualColumn
  },

  mixins: [estimateTableHeight],

  inject: ['tableKey', 'getTableKey'],

  props: {
    // 搜索条件
    queryForm: {
      type: Object,
      required: true
    },

    // 列表需要展示的列
    tableHeader: {
      type: Array,
      required: true
    },

    // 账单类型
    payableType: {
      type: [Number, String],
      default: '' // 1 安俊 2 第三方 3 AJD 4 DSP 5 运输（干/支线）
      // required: true
    }
  },

  data() {
    return {
      isSearch: false,
      tableData: [], // 总数据
      list: [],
      currentColumnsArr: [], // 扩展列
      total: 0,
      TRANSPORTATION_TYPE,
      CARGO_TYPE,
      CAR_LINE_TYPE
    };
  },

  computed: {
    key() {
      return this.getTableKey();
    }
  },

  methods: {
    // 搜索
    onSearch() {
      this.isSearch = false;
      this.queryForm.pageNumber = 1;
      this.asyncGetTable();
    },

    // 刷新
    onRefresh() {
      if (this.tableData.length === 0) {
        return;
      }
      this.asyncGetTable();
    },

    // 翻页
    onCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.asyncGetTable();
    },

    // 每页显示数量变化
    onSinzeChange(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.asyncGetTable();
    },

    // 获取列表数据
    processTableData(res) {
      if (res.code === 200) {
        const { data, total, columns } = res;
        this.total = total;
        // console.log(data, '列表数据');
        if (data.length > 0) {
          const { list, currentColumnsRow } = this.setColumns(columns);
          this.currentColumnsArr = list;
          this.tableData = this.setRowData(data, currentColumnsRow);
        } else {
          this.tableData = [];
          this.$message.warning(this.$t('operatingPlatform.nullMsg'));
        }
      }
    },

    asyncGetTable() {
      if (this.payableType === 5) {
        this.queryForm.params.ids = [];
        apiPayableTransportExpenseGetPage(this.queryForm).then(this.processTableData);
      } else {
        asyncGetList(this.queryForm).then(this.processTableData);
      }
    },

    // 扩展列
    setColumns(arr) {
      // console.log(arr, '动态列');
      const currentColumnsRow = {};
      const list = arr.map((item, index) => ({
        prop: item.prop,
        key: item.prop + index,
        label: item.label
        // label: label.split('_')[0],
        // fixed: 'left',
        // highlight: false
      }));

      arr.forEach(el => {
        currentColumnsRow[el.prop] = '';
      });

      return { list, currentColumnsRow };
    },

    // 列表行数据处理
    setRowData(arr, currentColumnsRow) {
      // 将数组
      return arr.map((item, index) => {
        const {
          status, feeSource, collectType
        } = item;

        // 订单状态
        const statusStr = this.queryForm.params.businessType === 2
          ? ORDER_TYPE_LIST.find(item => item.collectStatus === status)?.collectStatusName || ''
          : WAYBILL_STATUS.find(item => item.code === status)?.label || '';

        // 来源
        const feeSourceStr = FEE_SOURCE[feeSource]?.label || '';

        // 揽收方式
        const collectTypeStr = COLLECT_TYPE[collectType]?.label || '';

        // 扩展列
        // const row = {
        //   ...currentColumnsRow
        // };
        // for (const key in row) {
        //   console.log(key, 'key');
        //   console.log(item[key], 'item[key]');
        //   console.log(row[key], 'row[key]');
        //   // 存在
        //   if (item[key]) {
        //     row[key] = item[key];
        //   }
        // }
        // console.log(row, '扩展列');
        return {
          ...item,
          status, // 订单状态
          statusStr,
          collectType, // 揽收方式
          collectTypeStr,
          feeSource, // 来源
          feeSourceStr
        };
      });
    },

    // 多选
    handleSelectionChange(arr) {
      this.$emit('selection-change', arr);
    },

    // 详情查看
    editFee(row) {
      this.$emit('editFee', row);
    },

    /**
     * 重新table中el-columns，防止动态height丢失滚动条
     * @param h { createElement }
     * @param column
     * @param $index
     */
    renderHeader(h, { column, $index }) {
      let realWidth = 0;
      const span = document.createElement('span');
      span.textContent = column.label;
      document.body.appendChild(span);
      realWidth = span.offsetWidth; // 内容宽度+左右padding
      // realWidth = span.getBoundingClientRect().width;
      // console.log(realWidth, '999999999999999', column.label);
      column.minWidth = realWidth + 10;
      document.body.removeChild(span);
      return h('span', column.label);
    },

    // 获取总数量
    getTotalCount() {
      return this.total;
    }
  }
};
</script>

<style scoped>
/* 设置列宽超出... */
::v-deep .el-table th.el-table__cell > .cell {
  width: 100%;
  text-overflow: clip !important;
  white-space: nowrap !important;
}
::v-deep .ellipsis > .cell {
  width: 100% !important;
}
::v-deep .ellipsis > .cell > div {
  width: 100% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
